module.exports = __webpack_public_path__ + "static/media/relajo.79a94402.jpg";